import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: '', label: 'Todas' },
    { value: 'A', label: 'Ativo' },
    { value: 'E', label: 'Encerrado' },
    { value: 'R', label: 'Rescindido' },
    { value: 'S', label: 'Suspenso' },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaContratoCovid: ['administracao'],
    setTipoContratoConsultaContratoCovid: ['tipoContrato'],
    setExercicioContratoConsultaContratoCovid: ['exercicioContrato'],
    setNumeroContratoConsultaContratoCovid: ['numeroContrato'],
    setObjetoContratoConsultaContratoCovid: ['objetoContrato'],
    setNomeContratadoContratoConsultaContratoCovid: ['nomeContratadoContrato'],
    setTipoCompraConsultaContratoCovid: ['tipoCompra'],
    setSituacaoConsultaContratoCovid: ['situacao'],
    limpaFiltroConsultaContratoCovid: [],
    receberFiltroConsultaContratoCovid: ['filtroRecebido'],
    setStatusConsultaContratoCovid: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    exercicioContrato: '',
    numeroContrato: '',
    objetoContrato: '',
    modalidade: [],
    nomeContratadoContrato: '',
    tipoCompra: { label: 'Covid-19', value: 2 },
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setTipoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, tipoContrato: action.tipoContrato }
}

const setExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: action.exercicioContrato }
}

const setNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: action.numeroContrato }
}

const setObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: action.objetoContrato }
}

const setNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: action.nomeContratadoContrato }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_CONTRATO_COVID]: setAdministracao,
    [Types.SET_TIPO_CONTRATO_CONSULTA_CONTRATO_COVID]: setTipoContrato,
    [Types.SET_EXERCICIO_CONTRATO_CONSULTA_CONTRATO_COVID]: setExercicioContrato,
    [Types.SET_NUMERO_CONTRATO_CONSULTA_CONTRATO_COVID]: setNumeroContrato,
    [Types.SET_OBJETO_CONTRATO_CONSULTA_CONTRATO_COVID]: setObjetoContrato,
    [Types.SET_NOME_CONTRATADO_CONTRATO_CONSULTA_CONTRATO_COVID]: setNomeContratadoContrato,
    [Types.SET_TIPO_COMPRA_CONSULTA_CONTRATO_COVID]: setTipoCompra,
    [Types.SET_SITUACAO_CONSULTA_CONTRATO_COVID]: setSituacao,
    [Types.LIMPA_FILTRO_CONSULTA_CONTRATO_COVID]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CONTRATO_COVID]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CONTRATO_COVID]: setStatus,
})
